import styled from 'styled-components';

export const InputBase = styled.input`
  font-family: inherit;
  font-size: 100%;
  line-height: 1;
  margin: 0;
  background-image: none;
  box-shadow: none;
  overflow: visible;
  display: block;
  width: 100%;
  border: none;
  border-radius: 0;
  appearance: none;

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    height: auto;
  }
  &[type='search'] {
    outline-offset: -2rem;
  }
  &[type='search']::-webkit-search-cancel-button,
  &[type='search']::-webkit-search-decoration {
    appearance: none;
  }
  &::-webkit-file-upload-button {
    appearance: button;
    font: inherit;
  }
  &::-ms-expand {
    background-color: transparent;
    border: 0;
  }
  &:-moz-placeholder,
  &:focus {
    box-shadow: none !important; /* TODO: try &&& https://www.styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity */
  }

  input:invalid {
    box-shadow: none;
  }
`;

// export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
//   ref?: React.MutableRefObject<HTMLInputElement>;
// }

// export const InputBase: React.FC<InputProps> = props => {
//   return <InputStyled {...props} />;
// };
